import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';

export class UpdateExistingApplicationModal extends Component {

  handleHideModalUpdateExistingApplication = () => {
    this.props.handleCancelLoadExistingApplication()
  }
  handleRecoverExistingApplication = () => {
    this.props.handleRecoverExistingApplication();
  }
  handleReplaceExistingApplication = () => {
    this.props.handleReplaceExistingApplication();
  }

  render() {
    return (
        <div className="action-block">
          <Modal
              show={this.props.showModalUpdateExistingApplication}
              onHide={this.handleHideModalUpdateExistingApplication}
              container={this}
              dialogClassName="duplication-modal"
          >
            <Modal.Header
                className="duplication-modal-header"
            >
              <Modal.Title className="line-height-for-modal-title">
                <span className="question-sign-rectangle"><span
                    className="qmark"/></span>
                <span className="entity-id-modal-header">EntityID in use</span>
                <button className="entity-id-modal-close"
                        type="button"
                        onClick={this.handleHideModalUpdateExistingApplication}/>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body
                className="duplication-modal-body"
            >
              <div className="modal-text-item-top">
                The EntityID ({this.props.entityId}) in this
                metadata is in use by
                an existing application profile{' '}
                (<strong>{this.props.existingAppName}</strong>).
              </div>
              <div className="modal-text-item-middle">
                If you are trying to add
                {' '}<strong>{this.props.existingAppName}</strong>{' '}
                again after having restored a
                OneSign database backup, you can recover that
                profile.
              </div>
              <div className="modal-text-item-middle">
                If you want to use this metadata for a different
                application, you can replace{' '}
                <strong>{this.props.existingAppName}</strong>.

              </div>
              <div className="modal-text-item-bottom">
                <strong>{this.props.existingAppName}</strong>{' '}
                profile
              </div>
            </Modal.Body>
            <Modal.Footer
                className="duplication-modal-footer">
              <button
                  type="button"
                  className="btn btn-link duplication-button-left"
                  onClick={this.handleRecoverExistingApplication}
              >
                Recover
              </button>
              &nbsp;
              <button
                  type="button"
                  className="btn btn-link duplication-button-left"
                  onClick={this.handleReplaceExistingApplication}
              >
                Replace
              </button>
              <button
                  type="button"
                  className="btn btn-link duplication-button-right"
                  onClick={this.handleHideModalUpdateExistingApplication}
              >
                Choose different metadata
              </button>
            </Modal.Footer>
          </Modal>
        </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/AddSAML/ImportMetadata/UpdateExistingApplicationModal.js